import firstStepFormSubmit from '../modules/first-step-form-submit';
import SmoothScroll from 'smooth-scroll';

const valuationStartForm = document.getElementById('valuation-start');

const regInput = valuationStartForm.querySelector('input[name="reg_no"]');
const mileageInput = valuationStartForm.querySelector('input[name="mileage"]');

window.valuationWidget = firstStepFormSubmit(valuationStartForm, regInput, mileageInput, true);

const scroll = new SmoothScroll('.scroll-to-widget', {
    speed: 300
});



// WEBPACK FOOTER //
// ./resources/assets/js/valuations/we-want-your-car/index.js